<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="certification common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_Certification.jpg">
        <div class="banner-title font-large">
          <span>CERTIFICATION</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>CERTIFICATION</span>
          </div>
          <span class="article-title">CERTIFICATION</span>
          <div class="article-content">
            With the increasing concern for environmentally friendly fabrics and garments, all our fabric used are from the factory which got the certification of OEKO-TEX Stand 100 & CERES.
          </div>
        </div>
        <div class="mb-items">
          <ContactBox></ContactBox>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    
  }
}
</script>
<style lang="less">
  .certification{
    
  }
</style>
